import { render, staticRenderFns } from "./ResponsiveFormFields.vue?vue&type=template&id=b0388228&"
import script from "./ResponsiveFormFields.vue?vue&type=script&lang=js&"
export * from "./ResponsiveFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports